module.exports = __webpack_public_path__ + "media/images/clearangel-logo-5c3a94e646ec43569245c2b9ffc5cfbc.svg";